/**
 * @file 首页
 * @author putianyi
 */
import React, {useEffect, Suspense} from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Redirect, Route, Switch} from 'react-router-dom';
import {Spin} from 'antd';
import Layout from '../../components/Layout';
import Index from './components/Index';
import {homeSourceLog, webVisitLog} from './log/ubcLog';
import '../../styles/reset.less';
import '../../styles/global.less';

if (module.hot) {
    module.hot.accept();
}

// eslint-disable-next-line func-names
const App = function () {
    useEffect(() => {
        homeSourceLog();
        webVisitLog('visit');
    }, []);

    return (
        <Layout>
            <HashRouter>
                <Switch>
                    <Suspense fallback={<></>}>
                        <Route path="/" component={Index} />
                    </Suspense>
                </Switch>
            </HashRouter>
        </Layout>
    );
};

const containerId = 'root';
const rootElement = window.document.getElementById(containerId);

if (rootElement) {
    ReactDOM.render(<App />, document.getElementById('root'));
}

// pre render
export default locals => {
    const props = {}; // 这里的优先级高

    return Promise.resolve(locals.preRender({
        renderer: () => '',
        id: containerId, // 可选 默认：root
        main: App, // require
        props // 可选 默认：{}
    }));
};
